module.exports = __webpack_public_path__ + "static/SECURITI-a81681640a303207aee1fb993eed45fa.jpg";